/**
 * useNetworkStatus — Global network health monitor
 * 
 * Shows toast on connection loss/restore. Useful for workspace reliability.
 */

import { useEffect, useRef } from "react";
import { toast } from "sonner";

export function useNetworkStatus() {
  const wasOffline = useRef(false);

  useEffect(() => {
    const handleOffline = () => {
      wasOffline.current = true;
      toast.error("Geen internetverbinding", {
        description: "Controleer je netwerkverbinding en probeer opnieuw.",
        duration: Infinity,
        id: "network-offline",
      });
    };

    const handleOnline = () => {
      if (wasOffline.current) {
        wasOffline.current = false;
        toast.dismiss("network-offline");
        toast.success("Verbinding hersteld", {
          description: "Je bent weer online.",
          duration: 3000,
        });
      }
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    // Check initial state
    if (!navigator.onLine) {
      handleOffline();
    }

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);
}
